<div class="container-box">
  <app-table-header tableTitle="Azioni pratica" (btnUpdateClick)="loadActionPractices()">
    <app-button-new-action-practice action-button></app-button-new-action-practice>
  </app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="actionPracticesTable"
      class="table-content"
      [settings]="settings"
      [source]="source"
    ></ng2-smart-table>
  </div>
</div>
